import { Configuration } from '@azure/msal-browser';

const msal: { config: Configuration; tokenScopes: string[] } = {
  config: {
    auth: {
      clientId: process.env.REACT_APP_AAD_CLIENT_ID!,
      authority: process.env.REACT_APP_AAD_AUTHORITY!,
      redirectUri: process.env.REACT_APP_AAD_REDIRECT_URL!,
      postLogoutRedirectUri: process.env.REACT_APP_AAD_REDIRECT_URL!,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  },
  tokenScopes: process.env.REACT_APP_AAD_TOKEN_SCOPES!.split(','),
};

const pp: { apiUrl: string } = {
  apiUrl: process.env.REACT_APP_PP_API_URL!,
};

const nip: { apiUrl: string } = {
  apiUrl: process.env.REACT_APP_API_URL!,
};

const router: { basename?: string } = {
  basename: process.env.REACT_APP_BASE_NAME!,
};

const config = {
  msal,
  pp,
  nip,
  router,
  publicUrl: process.env.PUBLIC_URL,
  defaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE!,
  partnersLink: process.env.REACT_APP_PARTNERS_LINK!,
  ga: process.env.REACT_APP_GA!,
  gtm: process.env.REACT_APP_GTM!,
  dateFormat: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  } as Record<string, Intl.DateTimeFormatOptions>,
};

if (process.env.NODE_ENV !== 'production') {
  console.debug(config);
}

export { config };
